import type {
	Cart,
	Payment,
	PaymentMethodInfo,
} from "@commercetools/platform-sdk";

export type GiftCardData = {
	recipientName: string;
	recipientEmail: string;
	senderName?: string;
	message?: string;
};

export type GiftMessageData = {
	message?: string;
};

interface GiftCardPaymentMethodInfo extends PaymentMethodInfo {
	paymentInterface: "gift-card";
}

interface GiftCardPayment extends Payment {
	PaypalPaymentMethodInfo: GiftCardPaymentMethodInfo;
}

export const isGiftCardData = (data: unknown): data is GiftCardData => {
	const fieldData = data as GiftCardData | undefined;
	return Boolean(fieldData?.recipientEmail && fieldData.recipientName);
};

export const isGiftMessageData = (data: unknown): data is GiftMessageData => {
	const fieldData = data as GiftMessageData | undefined;
	return Boolean(fieldData?.message && fieldData.message);
};

export function isGiftCardPayment(
	paymentObject: Payment,
): paymentObject is GiftCardPayment {
	return paymentObject.paymentMethodInfo.paymentInterface === "gift-card";
}

export const cartHasGiftCardPayment = (cart: Cart) =>
	cart.paymentInfo?.payments.some(
		(payment) => payment.obj && isGiftCardPayment(payment.obj),
	);

export const cartHasGiftCardPaymentById = (cart: Cart, paymentId: string) =>
	cart.paymentInfo?.payments.some(
		(payment) =>
			payment.obj &&
			isGiftCardPayment(payment.obj) &&
			payment.obj.id === paymentId,
	);
